/* eslint-disable no-unused-vars */
import { forwardRef } from 'react';
import * as S from './DatePickerInput.styled';
import uuid from 'react-uuid';

function DatePickerInput(
  {
    isOpen,
    value,
    onClick,
    startDate,
    endDate,
    placeholderText,
    styledInput,
    showCalendar,
    selected,
    moveInputLeft,
    moveInputRight,
    leftIcon,
    rightIcon,
    disabled,
    rightIconAction,
    error,
  },
  ref,
) {
  let myMessage = {
    startTime: 'false',
    endTime: 'false',
  };
  if (startDate) {
    myMessage.startTime = 'true';
  } else myMessage.startTime = 'false';
  if (endDate) {
    myMessage.endTime = 'true';
  } else myMessage.endTime = 'false';

  return (
    <S.Container className='custom-input'>
      <S.StyledInputWrapper>
        <S.StyledInput
          error={error}
          ref={ref}
          isopen={isOpen}
          moveinputright={moveInputRight}
          moveinputleft={moveInputLeft}
          placeholder={placeholderText}
          autoComplete='off'
          //message={myMessage}
          id={uuid()}
          value={value}
          sx={styledInput}
          disabled={disabled}
          onClick={onClick}
        />
        {showCalendar && <S.LeftIconWrapper disabled={disabled}>{leftIcon}</S.LeftIconWrapper>}
        {selected && rightIcon && !disabled && (
          <S.RightIconWrap
            onClick={rightIconAction ? rightIconAction : onClick}
            disabled={disabled}
          >
            {rightIcon}
          </S.RightIconWrap>
        )}
      </S.StyledInputWrapper>
    </S.Container>
  );
}

export default forwardRef(DatePickerInput);
